import e from"./Snippet.vue_vue&type=script&lang.js";import{render as p}from"./Snippet.vue_vue&type=template&id=eb4966c6&lang.js";e.render=p,e.__file="src/components/Snippet.vue";export default e;
//# sourceMappingURL=Snippet.vue.js.map
